import * as NavConstants from 'constants/NavConstants';
import EditorRoutes from 'foundation/EditorRoutes';
import {RouteBundle} from 'routing/RouteConstants';

import {getDefaultRequestV2DefinitionListingSearchParams} from '../dashboard/RequestV2DefinitionListing';
import {getDefaultRequestsV2SubmissionListingSearchParams} from '../dashboard/RequestV2SubmissionListing';

export const RequestsV2Routes: RouteBundle = {
  domain: 'requests-v2',
  routes: [
    {
      urlPattern: ':currentUserUrl/request-v2-templates/:apiIdentifier',
      handler: EditorRoutes.requestV2DefinitionPage.bind(EditorRoutes),
      legacy: false,
    },
    {
      urlPattern: ':currentUserUrl/requests-v2/:apiIdentifier',
      handler: EditorRoutes.requestV2SubmissionEditor.bind(EditorRoutes),
      legacy: false,
    },
    {
      urlPattern: 'request-v2-submission/listing',
      handler: () => {
        EditorRoutes.sidepanelListing(
          NavConstants.SECTIONS.REQUESTS_V2_SUBMISSIONS,
          getDefaultRequestsV2SubmissionListingSearchParams()
        );
      },
      legacy: false,
    },
    {
      urlPattern: 'request-v2-template/listing',
      handler: () => {
        EditorRoutes.sidepanelListing(
          NavConstants.SECTIONS.REQUESTS_V2_DEFINITIONS,
          getDefaultRequestV2DefinitionListingSearchParams()
        );
      },
      legacy: false,
    },
  ],
};
